import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Sankey extends PureComponent {
    static propTypes = {
        data: PropTypes.object,
        outputList: PropTypes.array,
        inputList: PropTypes.array,
    };

    sankey = null;

    async componentDidMount() {
        // 引入 ECharts 主模块
        this.echarts = await import('echarts/lib/echarts');

        // 引入桑基图
        await import('echarts/lib/chart/sankey');
        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');

        const { data, outputList, inputList } = this.props;

        this.sankey = this.echarts.init(document.getElementById('sankey'));

        const xData = inputList
            .filter(item => item.name2 !== '中国')
            .reverse()
            .map(item => ({ name: item.name2, total: item.total }));

        let links = [];

        xData.forEach(item => {
            const link = Object.keys(data[item.name]).map(i => ({
                source: item.name,
                target: i,
                value: data[item.name][i],
            }));

            links = links.concat(link);
        });

        links = links.map(item => ({
            source: item.target,
            target: item.source,
            value: item.value,
        }));

        const yData = outputList
            .filter(item => item.outputName !== '未明确' && links.map(i => i.source).indexOf(item.outputName) > -1)
            .reverse()
            .map(item => ({ name: item.outputName, total: item.total }));
        const sd = xData
            .map(item => ({
                name: item.name,
                total: item.total,
                itemStyle: { normal: { borderWidth: 0 } },
                label: { position: 'left' },
            }))
            .concat(
                yData.map(item => ({
                    name: item.name,
                    total: item.total,
                    itemStyle: { normal: { borderWidth: 0 } },
                })),
            );

        const option = {
            tooltip: {
                trigger: 'item',
                formatter: params => {
                    if (params.dataType !== 'edge') {
                        if (xData.map(item => item.name).indexOf(params.name) > -1) {
                            return `<div style="font-size: 10px">共输入 ${params.name} ${params.data.total} 例</div>`;
                        } else {
                            return `<div style="font-size: 10px">${params.name} 共输出 ${params.data.total} 例</div>`;
                        }
                    }

                    return `<div style="font-size: 10px">
                        <p>来自：${params.data.source}</p>
                        <p>输入：${params.data.target}</p>
                        <p>病例：${params.data.value} 例</p>
                    </div>`;
                },
            },
            series: {
                type: 'sankey',
                draggable: false,
                data: sd,
                links,
                nodeWidth: 30,
                nodeGap: 15,
                top: 20,
                left: 0,
                right: 0,
                bottom: 10,
                layoutIterations: 0,
                nodeAlign: 'justify',
                focusNodeAdjacency: 'allEdges',
                lineStyle: {
                    color: 'target',
                    curveness: 0.5,
                },
                label: {
                    color: 'rgba(0,0,0,0.7)',
                    fontFamily: 'PingFangSC-Regular, PingFang SC',
                    fontSize: 10,
                },
            },
        };

        this.sankey.setOption(option);
    }

    render() {
        return (
            <div className={styles.line_box}>
                <div id="sankey" className={styles.box} />
            </div>
        );
    }
}

export default errorBoundary(Sankey);
